import React, { ReactElement } from 'react';
import moment from 'moment';
import './style.scss';

interface ContractSignatureInfoProps {
  form: GQL.IContractOnlineForm;
}

/**
 * Zobrazení informace o podpisu na smlouvě
 * - buď odesláním SMS
 * - nebo ručním podpisem
 *
 * @returns
 */
const ContractSignatureInfo = ({ form }: ContractSignatureInfoProps): ReactElement => {
  if (form?.signMethod?.toLowerCase() === 'signature') {
    return (
      <div className="signature-info">
        {form?.signatureFile && <img src={form?.signatureFile} alt="" />}
        <em>Podpísané {moment(form.signIn).format('D.M.YYYY vo H:mm')}.</em>
      </div>
    );
  }

  return (
    <>
      <br />
      <br />
      <br />
      <br />
      <em>
        Podpísané {moment(form.signIn).format('D.M.YYYY vo H:mm')} zadáním <br />
        podpisového kódu zaslaného na {form.signPhone}.
      </em>
    </>
  );
};

export default ContractSignatureInfo;
